import BaseController from "./BaseController";
import { AuthService } from "../service/Auth.service";
import JSONModel from "sap/ui/model/json/JSONModel";
import PropertyBinding from "sap/ui/model/PropertyBinding";
import String1 from "sap/ui/model/type/String";
import MessageToast from "sap/m/MessageToast";
import MessageBox from "sap/m/MessageBox";
import { ErrorHandler } from "../service/ErrorHandler.service";
import Input, { Input$LiveChangeEvent } from "sap/m/Input";
import InputBase, { InputBase$ChangeEvent } from "sap/m/InputBase";
import { CheckBox$SelectEvent } from "sap/m/CheckBox";

/**
 * @namespace com.unitrade.crm.controller
 */
export default class Login extends BaseController {
  _authService: AuthService;

  private _oModel: JSONModel;

  onInit(): void {
    this._authService = new AuthService();
    const rememberMeModel = this._authService.getRememberMeModel();

    this._oModel = new JSONModel({
      haus: rememberMeModel?.haus ?? 1,
      username: rememberMeModel?.username ?? "",
      password: "",
      hausLoading: true,
      submitting: false,
      rememberMe: this._authService.getDoNotRememberMe()
    });
    this.setModel(this._oModel);
  }

  public override getisNavBackEnabled(): Promise<boolean> {
    return Promise.resolve(false);
  }

  public async submit() {
    const aInputs = [this.byId("login_haus_input") as Input, this.byId("login_username_input") as Input, this.byId("login_password_input") as Input];
    let bValidationError = false;

    aInputs.forEach((oInput: Input) => {
      bValidationError = this._validateInput(oInput) || bValidationError;
    }, this);

    if (bValidationError) {
      MessageToast.show(await this.getTranslatedString("invalid_login_data"));
    } else {
      const oModel = this.getModel() as JSONModel;
      try {
        const haus: number = parseInt(oModel.getProperty("/haus"));
        const username: string = oModel.getProperty("/username").toUpperCase(); // U7 Logins are always uppercase
        const password: string = oModel.getProperty("/password");
        const rememberMe: boolean = oModel.getProperty("/rememberMe");
        oModel.setProperty("/submitting", true);

        const bResult = await this._authService.authenticate(haus, username, password, rememberMe);
        if (bResult === "OK") {



          oModel.setProperty("/password", "");
          const router = this.getOwnerComponent().getRouter();
          const currentHash = router.getHashChanger().getHash();
          const routeInfo = router.getRouteInfoByHash(currentHash);
          if (routeInfo.name === "loginWithRedirect") {
            const routeInfoArgs = JSON.parse(routeInfo.arguments.redirect as string);
            const routeName = routeInfoArgs.name;
            delete routeInfoArgs.name;
            router.navTo(routeName, routeInfoArgs);
          } else {
            router.navTo("home");
          }
        } else {
          MessageBox.error(bResult);
        }
      } catch (ex: any) {
        ErrorHandler.handleError(ex, { message: "Fehler beim Login", ignorable: true, onRetry: this.submit });
      } finally {
        oModel.setProperty("/submitting", false);
      }
    }
  }

  public onInputChange(oEvent: InputBase$ChangeEvent) {
    const oInput = oEvent.getSource();
    this._validateInput(oInput);
  }

  private _validateInput(oInput: InputBase) {
    let sValueState = "None";
    let bValidationError = false;
    const oBinding = oInput.getBinding("value") as PropertyBinding;

    try {
      const type = oBinding.getType() as String1;
      type.validateValue(oInput.getValue());
    } catch (oException) {
      sValueState = "Error";
      bValidationError = true;
    }

    oInput.setValueState(sValueState as "None" | "Error");

    return bValidationError;
  }

  public onlyNumbers = (oEvent: Input$LiveChangeEvent) => {
    var _oInput = oEvent.getSource();
    var val = _oInput.getValue();
    val = val.replace(/[^\d]/g, "");
    _oInput.setValue(val);
  };

  public onRememberMeSelect = (oEvent: CheckBox$SelectEvent) => {
    const selected = oEvent.getParameter("selected");
    if(!selected) this._authService.doNotRememberMe();
  }
}
